import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MLTab from './MLTab';
import s from './styles.module.css';

class MLTabPanel extends Component {
  static defaultProps = {
    tabClassName: '',
  };

  static propTypes = {
    children: PropTypes.instanceOf(Array).isRequired,
    activeTab: PropTypes.string,
    ariaLabel: PropTypes.string.isRequired,
    onTabClick: PropTypes.func,
    tabClassName: PropTypes.string,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const { activeTab } = nextProps;
    return activeTab !== prevState.activeTab ? { activeTab } : null;
  }

  constructor(props) {
    super(props);
    this.state = {
      activeTab: props.activeTab || this.props.children[0].props.label,
    };
  }

  onClickTabItem = (tab) => {
    const { onTabClick } = this.props;
    if (onTabClick) {
      onTabClick(tab);
    }
    this.setState({ activeTab: tab });
  };

  render() {
    const { activeTab } = this.state;
    const { children, tabClassName } = this.props;
    const children2 = children.filter((child) => !!child);

    return (
      <nav
        className={s.mlTabComponent}
        role="navigation"
        aria-label={this.props.ariaLabel}
      >
        <div className={s.mlTabPanel}>
          {children2.map((child) => {
            const { label, iconType, iconCSSClass } = child.props;
            const isActive = child.props.label === activeTab;
            return (
              <MLTab
                activeTab={isActive}
                key={label}
                label={label}
                tabClassName={tabClassName}
                onClick={this.onClickTabItem}
                iconType={iconType}
                iconCSSClass={iconCSSClass}
              />
            );
          })}
        </div>
        <div className={s.tabContent}>
          {children2.map((child) => {
            if (child.props.label !== activeTab) return undefined;
            return child.props.children;
          })}
        </div>
      </nav>
    );
  }
}

export default MLTabPanel;
